module.exports = __webpack_public_path__ + "assets/img/amazon.fe2aeb5c.png";